import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProverbsOfTheDay from '../../components/ProverbsOfTheDay'
import CharitySpotlight from '../../components/CharitySpotlight'

function getCurrentDate() {
  return window.__TEST_DATE__ || new Date()
}

function Home() {
  const date = getCurrentDate()

  return (
    <Row className="g-0 g-md-5">
      <Col xs={12} lg={7}>
        <ProverbsOfTheDay />
      </Col>
      <Col xs={12} lg={5}>
        <CharitySpotlight date={date} />
      </Col>
    </Row>
  )
}

export default Home
